import React, { useState, useMemo } from "react";
import { TextField, MenuItem, makeStyles } from "@material-ui/core";
import { connect } from "redux-zero/react";
import moment from "moment";
import { financialYears, periodLabel } from "../../financialYears";
import DateField from "../DateField";

const useStyles = makeStyles((theme) => ({
  periodSelect: {
    minWidth: 260,
  },
}));

const CUSTOM = "custom";

const mapToProps = ({ societyHeader }) => ({ societyHeader });

// Financial year dropdown with a Custom item that shows From and To date pickers
function PeriodSelector({ societyHeader, className, fromDate, toDate, setFromDate, setToDate }) {
  const classes = useStyles();
  const years = useMemo(
    () => (societyHeader ? financialYears(societyHeader) : []),
    [societyHeader]
  );
  const matchingIndex = years.findIndex(
    (x) =>
      moment(x.startDate).isSame(fromDate, "day") &&
      moment(x.endDate).isSame(toDate, "day")
  );
  const [custom, setCustom] = useState(false);
  const showCustom = custom || matchingIndex < 0;

  function handleChange(e) {
    if (e.target.value === CUSTOM) {
      setCustom(true);
      return;
    }
    const year = years[e.target.value];
    setCustom(false);
    setFromDate(year.startDate);
    setToDate(year.endDate);
  }

  return (
    <>
      <TextField
        select
        className={`${className} ${classes.periodSelect}`}
        label="Period"
        value={showCustom ? CUSTOM : matchingIndex}
        onChange={handleChange}
      >
        {years.map((year, index) => (
          <MenuItem key={year.startDate} value={index}>
            {periodLabel(year, societyHeader)}
          </MenuItem>
        ))}
        <MenuItem value={CUSTOM}>Custom</MenuItem>
      </TextField>
      {showCustom && (
        <>
          <DateField
            className={className}
            value={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
            label="From"
            onChange={(value) => {
              if (value) setFromDate(value);
            }}
          />
          <DateField
            className={className}
            value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
            label="To"
            onChange={(value) => {
              if (value) setToDate(value);
            }}
          />
        </>
      )}
    </>
  );
}

export default connect(mapToProps)(PeriodSelector);
